import React, { Fragment, useEffect, useState } from 'react';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import styled from 'styled-components';
import { CheckOutlined } from '@ant-design/icons';
import Button from '../../../../components/Button';
import { Form, message } from 'antd';
import { useParams } from 'react-router-dom';
import accountApis from '../../../../services/accountApis';

const responsive = {
  0: { items: 1 },
  600: { items: 2 },
  1024: { items: 3 },
};

const AliceCarouselInfo = () => {
  const form = Form.useFormInstance();
  const { id } = useParams();
  const [lstCouponTemplate, setLstCouponTemplate] = useState<any>(null);

  const handAddTemplate = async (templateId: string) => {
    form.setFieldsValue({ templateCouponId: templateId });
  };

  const fetchData = async () => {
    try {
      if (id) {
        const response = await accountApis.getLstCouponTemplateByType('MARKETING');
        if (response.status === 200) {
          setLstCouponTemplate(response.data.data);
        } else {
          message.error({ content: response.data.message, duration: 2 });
        }
      }
    } catch (error: any) {
      message.error({ content: error.message as string, duration: 2 });
    }
  };

  useEffect(() => {
    fetchData();
    return () => {
      form.setFieldsValue({ templateCouponId: '' });
    };
  }, []);

  return (
    <Form.Item shouldUpdate noStyle>
      {({ getFieldValue }) => {
        const value = getFieldValue('templateCouponId');
        return (
          <Form.Item
            name={'templateCouponId'}
            noStyle
            rules={[{ required: true, message: 'Please choose image coupon' }]}
          >
            <AliceCarousel key={'AliceCarousel'} responsive={responsive} disableDotsControls={true}>
              {lstCouponTemplate?.map((item: any) => (
                <Fragment key={item.id}>
                  <img alt='coupon' src={item.urlImage} onClick={() => handAddTemplate(item.id)} />
                  {value === item.id && (
                    <CheclTemplateStyled variant='PRIMARY'>
                      <CheckOutlined />
                    </CheclTemplateStyled>
                  )}
                </Fragment>
              ))}
            </AliceCarousel>
          </Form.Item>
        );
      }}
    </Form.Item>
  );
};

export default AliceCarouselInfo;

const CheclTemplateStyled = styled(Button)`
  border-radius: 50%;
  width: 30px;
  height: 30px;
  padding: 7px;
  position: absolute;
  top: 1%;
  right: 15%;
  z-index: 1;
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.4) 0px 5px 8px;
`;
